import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const Container = ({ border, fillHeight, children }: ContainerProps) => (
  <StyledContainer border={border} fillHeight={fillHeight}>{children}</StyledContainer>
);

export default Container;
